import ModalTemplate from "@/shared/components/ModalTemplate/ModalTemplate.vue";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import {
  COLLECTIONS_NAME,
  FORM_CONSTANTS,
  FORM_MESSAGES,
  FORM_VALIDATORS
} from "@/shared/constants/FormConstants";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { Component, Inject, Prop, Vue, Watch } from "vue-property-decorator";
import {
  ADD_CONDITION_DEEP_LEVEL,
  CONDITIONS,
  CUPS,
  CUPS_KEY_OPS,
  CUPS_LOWER_CASE,
  DATA_TYPES,
  DATE_LABEL,
  DATE_OPERATOR_KEY_NAME_ARRAY,
  DEEP_LEVEL_COLLECTIONS_ALLOWED,
  EQUAL_INCLUDES_OPERATORS_LIST,
  EQUAL_OPERATOR_KEY_NAME,
  FILTERS_NAMES_CONST,
  FORM_TEMPLATE,
  GENERAL_RULES_CONSTANTS,
  INCLUDE_OPERATOR_NAME,
  INFO_GROUPS,
  INFO_GROUPS_LABEL,
  INNER_CONDITIONS,
  INPUT_TYPE,
  KEYS_OF_USER_TEMPLATE_FORMS,
  KEY_LIST,
  LIST_OF_COLLECTIONS_WITH_CUPS_INNER_CONDITIONS,
  LIST_OF_COLLECTIONS_WITH_INNER_CONDITIONS,
  LIST_SAME_HANDLE_COLLECTIONS,
  NO_MULTIPLE,
  PRICE_LEVEL,
  SAME_OPERATOR_LIST_TYPES,
  SECOND_LEVEL,
  SELECT_TYPES,
  STATES_ARRAY,
  STATUS_FIELD_NAME,
  THIRD_LEVEL,
  TIME_ELAPSED,
  USER_CONDITION,
  USER_TEMPLATE,
  LABEL_SLIDER,
  EQUAL_AND_INCLUDES_OPERATORS,
  GENERAL_RULES_FILTERS_LIST,
  KEY_PROPERTY,
  NUMBER_OPERATORS_LIST
} from "../../constants/GeneralRulesConstants";
import { Collection } from "../../models/Collection.model";
import { ConditionGeneralRules } from "../../models/condition.model";
import {
  GenaralRuleField,
  Operator
} from "../../models/GenaralRuleField.model";
import { GeneralRule } from "../../models/GeneralRule";
import Display from "../Display/Display.vue";
import { Response } from "@/shared/models/Response";
import { UserPagination } from "@/modules/User/models/UserPagination";
import { UserService } from "@/modules/User/services/UserService";
import { Http } from "@status/codes";
import { List } from "@/shared/components/GenericSearchBar/model/List";
import Vuetify from "vuetify";
import { UserQuery } from "@/modules/User/models/UserQuery";
import DeepLevelCondition from "../DeepLevelConditions/DeepLevelConditions.vue";
import { FormTemplateService } from "@/modules/FormTemplate/services/FormTemplateService";
import { FormTemplate } from "@/modules/FormTemplate/models/FormTemplate";
import { Field } from "@/modules/FormTemplate/models/Field";
import { UserTemplateService } from "@/modules/UserTemplate/services/UserTemplateService";
import { HeaderInfoGroup } from "@/modules/InfoGroup/models/HeaderInfoGroup";
import { RequestInnerInfo } from "../../models/RequestInnerInfo.model";
import { InnerConditionToDb } from "../../models/InnerConditionToDb.model";
import { UserTemplate } from "@/modules/UserTemplate/models/UserTemplate";
import { InnerConditionOperator } from "../../models/InnerConditionsOperator.model";
import {
  ESCHEMA_TYPES,
  FORM_TEMPLATES_ACCESS
} from "@/modules/FormTemplate/constants/FormTemplateConstants";
import { FIELD_GROUP_CONSTANTS } from "@/modules/InfoGroup/constants/InfoGroupConstants";
import { AxiosError } from "axios";
import { USER_ACCESS } from "@/modules/User/constants/UserConstants";
import { USER_TEMPLATES_ACCESS } from "@/modules/UserTemplate/constants/UserTemplateConstants";
import { GeneralRulesService } from "../../services/GeneralRulesService";
import { Utils } from "@/shared/utils/utils";
import { ServiceTemplateService } from "@/modules/ServiceTemplate/services/ServiceTemplateService";
import { ServiceTemplateHeader } from "@/modules/ServiceTemplate/models/ServiceTemplateHeader";
import { ServiceTemplateModel } from "@/modules/ServiceTemplate/models/ServiceTemplateModel";
import DynamicSelect from "@/shared/components/DynamicSelect/DynamicSelect.vue";
import lodash from "lodash";
import _ from "lodash";
import { mapGetters } from "vuex";
import { ConditionForm } from "../../models/ConditionForm.model";

Vue.use(Vuetify);
@Component({
  name: "Conditions",
  components: {
    ModalTemplate,
    Display,
    DeepLevelCondition,
    DynamicSelect
  },
  computed: {
    ...mapGetters({
      groupsLevels: "getGroupsLevels"
    })
  }
})
export default class Conditions extends Vue {
  @Inject() userService!: UserService;
  @Inject() formTemplateService!: FormTemplateService;
  @Inject() userTemplateService!: UserTemplateService;
  @Inject() generalRulesService!: GeneralRulesService;
  @Inject() serviceTemplateService!: ServiceTemplateService;

  @Prop() fetchConditions!: boolean;
  @Prop() rule!: GeneralRule;
  @Prop() isEditing!: boolean;
  @Prop() ruleId!: string;
  @Prop() newRule!: boolean;

  resetConditionData = 0;
  requiredField = [
    FORM_VALIDATORS.REQUIRED_FIELD,
    FORM_VALIDATORS.NOT_BLANK_SPACES_VALIDATOR
  ];
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  btnClassPrimaryRound = STYLE_CLASSES.PRIMARY_ROUND_BTN;
  ADD_CONDITION = FORM_CONSTANTS.BUTTON.ADD_CONDITION;
  generalRules = false;
  switchClass = STYLE_CLASSES.SWITCH;
  RULE_NAME = GENERAL_RULES_CONSTANTS.LABEL.RULE_NAME;
  DESCRIPTION = GENERAL_RULES_CONSTANTS.LABEL.DESCRIPTION;
  priBtnClass = STYLE_CLASSES.PRIMARY_BTN;
  valueBtn = STYLE_CLASSES.SECONDARY_BTN;
  filterArray = [...GENERAL_RULES_CONSTANTS.DROPDOWN_SERVICES];
  fields: Array<string> = [];
  operators: Array<string> = [];
  TITLE_BUTTON_SERVICES = GENERAL_RULES_CONSTANTS.TITLE_BUTTON_SERVICES;
  enableAddNewConditionButton = false;
  serviceButtonDisable = false;
  selectedField = "";
  dialogDelete = false;
  modalText = GENERAL_RULES_CONSTANTS.MESSAGES.DELETE_CONDITION_TEXT;
  modalTitle = GENERAL_RULES_CONSTANTS.MESSAGES.DELETE_CONDITION_TITLE;
  indexConditionToDelete = -1;
  display = "";
  roundBtnClass = STYLE_CLASSES.TERTIARY_ROUND_BTN;
  roundPrimaryBtnClass = STYLE_CLASSES.ROUND_BTN_CLASS;
  DELETE_CONDITION = GENERAL_RULES_CONSTANTS.DELETE_CONDITION;
  cups = [];
  cupsSelected: List[] = [];
  INCLUDE_OPERATOR = GENERAL_RULES_CONSTANTS.INCLUDE_OPERATOR;
  UsersListEnable?: number[] = [];
  userList: List[][] = [];
  VALIDATE_USER = GENERAL_RULES_CONSTANTS.VALIDATE_USER;
  operatorChanged = false;
  indexOperatorChanged = "";
  ACTIVO = GENERAL_RULES_CONSTANTS.ACTIVO;
  cleanForm = 1;
  showConditionDeepLevelContainer: number[] = [];
  innerConditionFields: Array<RequestInnerInfo[]> = [];
  operatorCondition = "";
  displayValue = "";
  currentConditions: ConditionGeneralRules[] = [];

  dataToDeepLevelConditions: Array<InnerConditionToDb[]> = [];
  dataToRefreshData: ConditionGeneralRules[] = [];
  fieldsFromFormTemplate: RequestInnerInfo[] = [];
  groupServiceTemplateConditions: RequestInnerInfo[] = [];
  innerInfoGroupsConditions: RequestInnerInfo[] = [];
  thirldLevelConditionsArray: InnerConditionToDb[] = [];
  indexIterator = 1;
  deleteCounter = 1;
  ADD_CONDITION_DEEP_LEVEL = ADD_CONDITION_DEEP_LEVEL;
  filterCollections: Collection[] = this.filterArray;
  keyWord = "";
  errorsName: string[] = [];
  serviceTemplates: ServiceTemplateHeader[] = [];
  serviceTemplate: ServiceTemplateModel = new ServiceTemplateModel();
  groupsLevels!: any[];
  editComparationStr = "";
  invalidEdit = false;
  callCounter = 0;
  conditionForm: ConditionForm = {
    inputRuleName: "",
    inputRuleDescription: "",
    collection: {
      name: GENERAL_RULES_CONSTANTS.TITLE_BUTTON_SERVICES,
      fields: [],
      key: ""
    },
    conditions: [
      { key: "", operator: "", value: "", operatoresList: [], display: "" }
    ]
  };

  async mounted() {
    await this.changeRule();
  }
  @Watch("conditionForm", { deep: true })
  checkEdit() {
    if (this.isEditing && this.callCounter >= 5) {
      this.invalidEdit =
        JSON.stringify(this.conditionForm) === this.editComparationStr;
      this.$emit(GENERAL_RULES_CONSTANTS.EMITTERS.CHECK_CONDITION_EDIT, {
        equal: this.invalidEdit
      });
    } else if (this.isEditing && this.callCounter < 5) {
      this.editComparationStr = JSON.stringify(this.conditionForm);
      this.callCounter += 1;
    }
  }

  @Watch("newRule")
  @Watch("isToEdit")
  listenIsToEdit() {
    if (!this.isEditing) {
      this.conditionForm.inputRuleName = "";
      this.conditionForm.inputRuleDescription = "";
      this.conditionForm.conditions = [
        { key: "", operator: "", value: "", operatoresList: [], display: "" }
      ];
      this.enableAddNewConditionButton = false;
      this.cleanForm = 1 - this.cleanForm;
    }
  }

  @Watch("rule")
  async changeRule() {
    this.showConditionDeepLevelContainer = [];
    this.dataToDeepLevelConditions = [];
    this.innerConditionFields = [];
    this.fieldsFromFormTemplate = [];
    this.groupServiceTemplateConditions = [];
    this.innerInfoGroupsConditions = [];
    const findFormTempCondition = this.rule.conditions.find(
      condition =>
        (condition.innerConditions?.length ?? 0) > 0 &&
        condition.key === FORM_TEMPLATE
    );
    const findInfoGroupsCondition = this.rule.conditions.find(
      condition =>
        (condition.innerConditions?.length ?? 0) > 0 &&
        condition.key === USER_TEMPLATE
    );

    const findServiceTemplateCondition = this.rule.conditions.find(
      condition =>
        (condition.innerConditions?.length ?? 0) > 0 &&
        condition.key === GENERAL_RULES_CONSTANTS.SERVICE
    );

    if (findServiceTemplateCondition !== undefined) {
      const groupsInnerCondition = findServiceTemplateCondition.innerConditions?.find(
        condition => condition.key === GENERAL_RULES_CONSTANTS.GROUPS
      );
      if (groupsInnerCondition !== undefined) {
        this.groupServiceTemplateConditions =
          (await this.getServiceTemplate(
            findServiceTemplateCondition.value[0]
          )) ?? [];
      }
    }

    if (findFormTempCondition !== undefined) {
      this.fieldsFromFormTemplate =
        (await this.getFieldsFromFormTemplateById(
          findFormTempCondition.value[0]
        )) ?? [];
    }

    if (findInfoGroupsCondition !== undefined) {
      const infoGroupLevelInnerCondition = findInfoGroupsCondition.innerConditions?.find(
        condition => condition.key === INFO_GROUPS
      );
      if (infoGroupLevelInnerCondition !== undefined) {
        this.innerInfoGroupsConditions =
          (await this.getInfoGroupsByUserTemplateId(
            findInfoGroupsCondition.value[0]
          )) ?? [];
      }
    }
    this.conditionForm.collection = {
      name: GENERAL_RULES_CONSTANTS.TITLE_BUTTON_SERVICES,
      fields: [],
      key: ""
    };
    this.conditionForm.inputRuleName = "";
    this.conditionForm.inputRuleDescription = "";
    this.UsersListEnable = [];
    this.userList = [];
    this.conditionForm.conditions = [
      { key: "", operator: "", value: "", operatoresList: [], display: "" }
    ];

    if (this.isEditing) {
      this.editConditions(this.rule);
      return;
    }
    this.listenIsToEdit();
    this.editComparationStr = JSON.stringify(this.conditionForm);
  }

  deleteAllInnerConditions() {
    this.showConditionDeepLevelContainer = [];
  }

  setFields(item: Collection) {
    this.keyWord = "";
    this.filterCollections = this.filterArray;

    if (this.conditionForm.collection.name !== item.name) {
      this.conditionForm.conditions = [
        { key: "", operator: "", value: "", operatoresList: [], display: "" }
      ];
      this.deleteAllInnerConditions();
      this.conditionForm.collection = item;
      this.$emit(
        GENERAL_RULES_CONSTANTS.EMITTERS.SEND_COLLECTION,
        this.conditionForm.collection
      );
      this.fields = item.fields.map((element: GenaralRuleField) => {
        return element.field;
      });
      if (this.conditionForm.collection.key == FILTERS_NAMES_CONST.TASK.KEY) {
        const index = this.fields.findIndex(
          field => field == USER_CONDITION.field
        );
        if (index != -1) this.fields.splice(index, 1);
      }
      this.operators = [];
      this.enableAddNewConditionButton = false;
      this.activeSaveButton();
    }
  }

  setOperators(item: string, index: number) {
    this.deleteDeepCondition(index);
    this.deleteGroupLevelsConditionWhenChangeField(index, item);
    this.handleUserConditionForTask();
    if (
      this.conditionForm.collection.key != FILTERS_NAMES_CONST.SESSION.KEY &&
      item == FILTERS_NAMES_CONST.TIME_ELAPSED.name &&
      !this.conditionForm.conditions.find(
        (condition, i) => condition.key === STATUS_FIELD_NAME && i !== index
      )
    ) {
      this.conditionForm.conditions[index].key = "";
      this.conditionForm.conditions[index].operator = "";
      this.conditionForm.conditions[index].display = "";
      this.conditionForm.conditions[index].value = "";
      this.conditionForm.conditions[index].operatoresList = [];
      this.resetConditionData = 1 - this.resetConditionData;
      Snackbar.popError(GENERAL_RULES_CONSTANTS.MESSAGES.REQUIRED_STATE);
      const conditions = {
        collection: this.conditionForm.collection.name,
        ruleName: this.conditionForm.inputRuleName.trim(),
        ruleDescription: this.conditionForm.inputRuleDescription.trim(),
        conditions: this.conditionForm.conditions
      };
      this.$emit(
        GENERAL_RULES_CONSTANTS.EMITTERS.SEND_CONDITION_TO_SAVE,
        conditions
      );
      return;
    }
    const equalCondition = this.conditionForm.conditions.find(
      condition => condition.key === String(item)
    );

    if (equalCondition !== undefined) {
      Snackbar.popError(GENERAL_RULES_CONSTANTS.MESSAGES.EXIST_CONDITION);
      return;
    }

    const validateCodependency = this.checkCodependecy(item);

    if (validateCodependency) {
      Snackbar.popError(
        GENERAL_RULES_CONSTANTS.MESSAGES.REQUIRED_CODEPENDENCY +
          validateCodependency
      );
      return;
    }
    if (String(item) === PRICE_LEVEL) {
      const findCups = this.conditionForm.conditions.find(
        (item, i) => item.key === CUPS && i !== index
      );
      if (findCups === undefined) {
        this.conditionForm.conditions[index].key = "";
        this.conditionForm.conditions[index].operator = "";
        this.conditionForm.conditions[index].display = "";
        this.conditionForm.conditions[index].value = "";
        this.conditionForm.conditions[index].operatoresList = [];
        this.resetConditionData = 1 - this.resetConditionData;
        const conditions = {
          collection: this.conditionForm.collection.name,
          ruleName: this.conditionForm.inputRuleName.trim(),
          ruleDescription: this.conditionForm.inputRuleDescription.trim(),
          conditions: this.conditionForm.conditions
        };
        this.$emit(
          GENERAL_RULES_CONSTANTS.EMITTERS.SEND_CONDITION_TO_SAVE,
          conditions
        );
        Snackbar.popError(GENERAL_RULES_CONSTANTS.MESSAGES.MUST_HAVE_CUPS);
        return;
      }
    }

    this.selectedField = String(item);
    const field = this.conditionForm.collection.fields.find(
      (element: GenaralRuleField) => element.field === item
    )!;

    const conditions = [...this.conditionForm.conditions];
    this.display = field.display;
    conditions[index].operator = "";
    conditions[index].value = "";
    conditions[index].display = field.display;
    conditions[index].key = this.selectedField;
    conditions[index].operatoresList = field.operators.map(
      (element: Operator) => element.operator
    );
    this.conditionForm.conditions = conditions;
    this.activeSaveButton();
  }

  handleUserConditionForTask() {
    if (this.conditionForm.collection.key == FILTERS_NAMES_CONST.TASK.KEY) {
      const indexFilterArray = this.filterArray.findIndex(
        array => array.key == this.conditionForm.collection.key
      );
      if (indexFilterArray) {
        const dependencyCondition = this.conditionForm.conditions.find(
          condition =>
            condition.key === FILTERS_NAMES_CONST.TASK.FIELDS.DEPENDENCY.name
        );

        if (dependencyCondition) {
          if (dependencyCondition.value.length > 1) {
            if (!this.fields.find(field => field == USER_CONDITION.field))
              this.fields.push(USER_CONDITION.field);
          } else {
            const index = this.fields.findIndex(
              field => field == USER_CONDITION.field
            );
            if (index != -1) {
              this.fields.splice(index, 1);
            }
          }
        } else {
          const index = this.fields.findIndex(
            field => field == USER_CONDITION.field
          );
          if (index != -1) this.fields.splice(index, 1);
        }
      }
    }
  }

  setValues(item: string, index: number) {
    this.deleteDeepCondition(index);
    this.operatorCondition = item;
    const exist = this.conditionForm.conditions.find(element => {
      return (
        element.key === this.conditionForm.conditions[index].key &&
        element.operator === String(item) &&
        element.value === this.conditionForm.conditions[index].value &&
        element.value !== ""
      );
    });

    const validateCoDepOperatorChange = this.checkIfIsCodependent(
      this.conditionForm.conditions[index].key,
      item,
      false
    );

    if (exist === undefined && validateCoDepOperatorChange) {
      this.conditionForm.conditions[index].operator = String(item);
      this.enableAddNewConditionButton = false;
      this.operatorChanged = !this.operatorChanged;
      this.indexOperatorChanged = index.toString();
      this.activeSaveButton();
      return;
    }
    if (validateCoDepOperatorChange) {
      Snackbar.popError(GENERAL_RULES_CONSTANTS.MESSAGES.EXIST_CONDITION);
    }
    this.conditionForm.conditions[index].operator = undefined!;
    this.activeSaveButton();
  }

  setInnerConditionsThirdLevel(
    accArray: InnerConditionToDb[],
    indexMacro: number
  ) {
    this.thirldLevelConditionsArray = [...accArray];
    const thridLevelParentValue = this.thirldLevelConditionsArray.map(
      level =>
        ({
          level: THIRD_LEVEL,
          key: level.key,
          value: level.value,
          operation: level.operation
        } as InnerConditionToDb)
    );
    let secondLevelCondition = {};

    if (this.conditionForm.conditions[indexMacro].innerConditions) {
      if (
        this.conditionForm.conditions[indexMacro].innerConditions!.length > 0
      ) {
        secondLevelCondition = JSON.parse(
          JSON.stringify(
            this.conditionForm.conditions[indexMacro].innerConditions![0]
          )
        );
      }
    }
    if (Object.keys(secondLevelCondition).length > 0) {
      this.conditionForm.conditions[indexMacro].innerConditions = [
        secondLevelCondition as InnerConditionToDb,
        ...thridLevelParentValue
      ];
    }

    this.saveConditions();
  }

  setInnerConditions(accArray: any[], indexMacro: number) {
    if (this.currentConditions.length === 0) {
      this.currentConditions = JSON.parse(
        JSON.stringify(this.conditionForm.conditions)
      );
    }
    if (
      LIST_SAME_HANDLE_COLLECTIONS.includes(this.conditionForm.collection.key)
    ) {
      const conditionsAux: InnerConditionToDb[] = [];
      accArray.forEach(acc => {
        if (acc.collection.key === FILTERS_NAMES_CONST.FORM.KEY) {
          conditionsAux.push({
            level: SECOND_LEVEL,
            key: acc.key,
            operation: acc.operation,
            value: acc.value
          });
          this.conditionForm.conditions[
            indexMacro
          ].innerConditions = conditionsAux;
        } else if (
          LIST_OF_COLLECTIONS_WITH_CUPS_INNER_CONDITIONS.includes(
            acc.collection.key
          )
        ) {
          this.conditionForm.conditions[indexMacro].innerConditions = [
            {
              level: SECOND_LEVEL,
              key: acc.key,
              value: acc.value,
              operation: acc.operation
            }
          ];
        }
      });
    } else if (
      this.conditionForm.collection.key === FILTERS_NAMES_CONST.USER.KEY &&
      accArray.length === 1
    ) {
      this.conditionForm.conditions[indexMacro].innerConditions = [];
      const secondLevelParentValue = {
        level: SECOND_LEVEL,
        value: accArray[0].value,
        key: accArray[0].key,
        operation: accArray[0].operation
      };
      this.conditionForm.conditions[indexMacro].innerConditions!.push(
        secondLevelParentValue
      );
    } else if (
      this.conditionForm.collection.key === FILTERS_NAMES_CONST.USER.KEY &&
      accArray.length === 0
    ) {
      delete this.conditionForm.conditions[indexMacro].innerConditions;
    }
    this.saveConditions();
  }

  setCondition(item: ConditionGeneralRules, index: number, timeUnit?: string) {
    this.conditionForm.conditions[index].value = item;
    this.conditionForm.conditions[index].timeUnit = timeUnit ? timeUnit : "";
    this.enableAddNewConditionButton = true;

    if (
      this.conditionForm.conditions[index].key ==
        FILTERS_NAMES_CONST.TIME_ELAPSED.name &&
      this.conditionForm.conditions[index].timeUnit == "" &&
      this.conditionForm.conditions[index].value !== ""
    ) {
      Snackbar.popWarning(GENERAL_RULES_CONSTANTS.MESSAGES.REQUIRED_TIME_UNIT);
      return;
    }

    this.saveConditions();
    this.activeSaveButton();

    this.currentConditions = JSON.parse(
      JSON.stringify(this.conditionForm.conditions)
    );
  }

  @Watch("conditionForm.inputRuleName")
  @Watch("conditionForm.inputRuleDescription")
  activeSaveButton() {
    this.$emit(GENERAL_RULES_CONSTANTS.EMITTERS.DISABLE_BUTTON);
  }

  createNewCondition() {
    this.handleUserConditionForTask();

    this.conditionForm.conditions.push({
      key: "",
      operator: "",
      value: "",
      operatoresList: [],
      display: ""
    });
    this.enableAddNewConditionButton = false;
    this.saveConditions();
  }

  deleteCondition(index: number) {
    this.indexConditionToDelete = index;
    if (this.conditionForm.conditions.length === 1) {
      Snackbar.popWarning(
        GENERAL_RULES_CONSTANTS.MESSAGES.MUST_EXIST_ONE_CONDITION
      );
      return;
    }
    this.dialogDelete = true;
  }

  handleModalAccept() {
    this.deleteGroupLevelsCondition();

    const currentConditions = JSON.parse(
      JSON.stringify(this.conditionForm.conditions)
    );
    if (
      this.indexConditionToDelete !== -1 &&
      Object.keys(currentConditions[this.indexConditionToDelete]).includes(
        INNER_CONDITIONS
      ) &&
      currentConditions[this.indexConditionToDelete].innerConditions.length > 0
    ) {
      this.deleteDeepCondition(this.indexConditionToDelete);
    }
    const validateCodependency = this.checkIfIsCodependent(
      this.conditionForm.conditions[this.indexConditionToDelete].key,
      "",
      true
    );
    if (!validateCodependency) {
      this.dialogDelete = false;
      return;
    }
    const verifyCupsAndLevelPri = this.verifyIfExistBothConditions(
      this.indexConditionToDelete
    );
    if (verifyCupsAndLevelPri) {
      Snackbar.popError(
        GENERAL_RULES_CONSTANTS.MESSAGES.MUST_DELETE_LEVEL_PRICE
      );
      this.dialogDelete = false;
      return;
    }
    const verifyStatusAndElapsedTime = this.verifyIfExistBothConditions(
      this.indexConditionToDelete,
      STATUS_FIELD_NAME
    );
    if (verifyStatusAndElapsedTime) {
      Snackbar.popError(
        GENERAL_RULES_CONSTANTS.MESSAGES.MUST_DELETE_ELAPSED_TIME
      );
      this.dialogDelete = false;
      return;
    }
    currentConditions.splice(this.indexConditionToDelete, 1);
    this.conditionForm.conditions = currentConditions;

    if (this.isEditing) {
      this.dataToDeepLevelConditions = [];
    }
    // this.deleteCounter++;
    this.dataToRefreshData = (JSON.parse(
      JSON.stringify(this.conditionForm.conditions)
    ) as ConditionGeneralRules[]).filter(element =>
      Object.keys(element).includes(INNER_CONDITIONS)
    );

    const newConditionDeepLevelContainer: number[] = [];
    this.conditionForm.conditions.forEach((condition, index) => {
      if (
        Object.keys(condition).includes(INNER_CONDITIONS) &&
        (condition.innerConditions ?? []).length > 0
      ) {
        newConditionDeepLevelContainer.push(index);
      }
    });

    this.showConditionDeepLevelContainer = [...newConditionDeepLevelContainer];

    Vue.set(this.rule, CONDITIONS, [...this.conditionForm.conditions]);

    this.dialogDelete = false;
    for (const condition of this.conditionForm.conditions) {
      if (!condition.key || !condition.operator || !condition.value) {
        this.enableAddNewConditionButton = false;
        break;
      }
    }
    this.enableAddNewConditionButton = true;
    this.handleUserConditionForTask();
  }

  verifyIfExistBothConditions(index: number, preconditionKey: string = CUPS) {
    if (this.conditionForm.conditions[index].key === preconditionKey) {
      const key = preconditionKey === CUPS ? PRICE_LEVEL : TIME_ELAPSED.name;
      const findCondition = this.conditionForm.conditions.find(
        element => element.key === key
      );

      if (findCondition !== undefined) {
        return true;
      }
      return false;
    }
    return false;
  }

  handleModalCancel() {
    this.dialogDelete = false;
  }

  @Watch("fetchConditions")
  saveConditions() {
    const conditions = {
      collection: this.conditionForm.collection.name,
      ruleName: this.conditionForm.inputRuleName.trim(),
      ruleDescription: this.conditionForm.inputRuleDescription.trim(),
      conditions: this.conditionForm.conditions
    };
    this.$emit(
      GENERAL_RULES_CONSTANTS.EMITTERS.SEND_CONDITION_TO_SAVE,
      conditions
    );
  }

  getValue(event: any) {
    event.value = event.value[0];
    this.displayValue = event;
    if (this.conditionForm.conditions[event.index].key === CUPS) {
      this.cupsSelected = event.value;
    }
    if (event.status) this.deleteDeepCondition(event.index);
    this.setCondition(event.value, parseInt(event.index), event.timeUnit);
    this.handleUserConditionForTask();
    this.addLevelGroupAndStateGroupConditionServiceType(event);
  }

  editConditions(rule: GeneralRule) {
    this.editComparationStr = "";
    this.invalidEdit = true;
    this.callCounter = 0;
    const ruleAux = JSON.parse(JSON.stringify(rule)) as GeneralRule;
    this.conditionForm.inputRuleName = ruleAux.name.trim();
    this.conditionForm.inputRuleDescription = ruleAux.description.trim();
    const dropdownServices: Collection[] = lodash.cloneDeep(
      GENERAL_RULES_CONSTANTS.DROPDOWN_SERVICES
    );
    const collection = dropdownServices.find(
      element =>
        element.key === rule.collection || element.name === rule.collection
    );
    if (collection !== undefined) {
      const collectionClone = { ...collection };
      if (rule.collection == "services") {
        this.addGroupLevelsFields(collectionClone, rule);
        this.addSessionsFields(collectionClone, rule);
      }
      this.conditionForm.collection.name = collectionClone.name;
      this.conditionForm.collection.fields = collectionClone.fields as Array<
        GenaralRuleField
      >;
      this.conditionForm.collection.key = collectionClone.key;
      this.$emit(
        GENERAL_RULES_CONSTANTS.EMITTERS.SEND_COLLECTION,
        this.conditionForm.collection
      );
      this.fields = collectionClone.fields.map(
        (item: GenaralRuleField) => item.field
      );
      const conditions = rule.conditions.map((condition, index) => {
        const findField = collectionClone.fields.find(
          item => item.key === condition.key
        );
        const conditionToRender = {} as ConditionGeneralRules;
        if (findField !== undefined) {
          conditionToRender.key = findField.field;
          conditionToRender.operator = findField.operators.find(
            item => item.key === condition.operator
          )?.operator!;
          conditionToRender.operatoresList = findField.operators.map(
            item => item.operator
          );
          conditionToRender.display = findField.display;
          conditionToRender.timeUnit = condition.timeUnit || "";
          const cupsCondition =
            condition.key === CUPS_LOWER_CASE &&
            (condition.innerConditions ?? []).length > 0
              ? true
              : false;
          const templateCondition =
            condition.key === FORM_TEMPLATE &&
            (condition.innerConditions ?? []).length > 0
              ? true
              : false;
          const serviceTemplateCondition =
            condition.key === GENERAL_RULES_CONSTANTS.SERVICE &&
            (condition.innerConditions ?? []).length > 0;
          const userTemplateCondition =
            condition.key === USER_TEMPLATE &&
            (condition.innerConditions ?? []).length > 0
              ? true
              : false;
          if (
            LIST_OF_COLLECTIONS_WITH_CUPS_INNER_CONDITIONS.includes(
              collectionClone.key
            ) &&
            cupsCondition
          ) {
            conditionToRender.value = condition.value;
            this.dataToDeepLevelConditions[index] =
              condition.innerConditions ?? [];
            this.showConditionDeepLevelContainer.push(index);
            this.innerConditionFields[index] = [...CUPS_KEY_OPS];
          } else if (
            collectionClone.key === FILTERS_NAMES_CONST.FORM.KEY &&
            templateCondition
          ) {
            conditionToRender.value = condition.value;
            this.dataToDeepLevelConditions[index] =
              condition.innerConditions ?? [];
            this.showConditionDeepLevelContainer.push(index);
            this.innerConditionFields[index] = [...this.fieldsFromFormTemplate];
          } else if (
            collectionClone.key === FILTERS_NAMES_CONST.FORM.KEY &&
            serviceTemplateCondition
          ) {
            conditionToRender.value = condition.value;
            this.dataToDeepLevelConditions[index] =
              condition.innerConditions ?? [];
            this.showConditionDeepLevelContainer.push(index);
            this.innerConditionFields[index] = [
              ...this.groupServiceTemplateConditions
            ];
          } else if (
            collectionClone.key === FILTERS_NAMES_CONST.USER.KEY &&
            userTemplateCondition
          ) {
            conditionToRender.value = condition.value;
            this.dataToDeepLevelConditions[index] =
              condition.innerConditions ?? [];
            this.showConditionDeepLevelContainer.push(index);
            this.innerConditionFields[index] = [
              ...this.innerInfoGroupsConditions
            ];
          } else {
            conditionToRender.value = condition.value;
          }
        }
        return conditionToRender;
      });
      this.conditionForm.conditions = conditions;
    }
  }
  addGroupLevelsFields(
    collectionClone: {
      key: string;
      name: string;
      fields: Array<GenaralRuleField>;
    },
    rule: GeneralRule
  ) {
    rule.conditions.forEach(condition => {
      FILTERS_NAMES_CONST.SERVICE.FIELDS.GROUP_LEVEL.key;
      if (
        [
          FILTERS_NAMES_CONST.SERVICE.FIELDS.GROUP_LEVEL.key,
          FILTERS_NAMES_CONST.SERVICE.FIELDS.STATE_GROUP_LEVEL.key
        ].includes(condition.key)
      ) {
        const fieldFound = collectionClone.fields.find(
          item => item.key == condition.key
        );
        if (!fieldFound) {
          collectionClone.fields.push({
            key: condition.key,
            field:
              condition.key ===
              FILTERS_NAMES_CONST.SERVICE.FIELDS.GROUP_LEVEL.key
                ? FILTERS_NAMES_CONST.SERVICE.FIELDS.GROUP_LEVEL.name
                : FILTERS_NAMES_CONST.SERVICE.FIELDS.STATE_GROUP_LEVEL.name,
            operators: EQUAL_AND_INCLUDES_OPERATORS,
            display: INPUT_TYPE.SELECT,
            showInStopConditios: false
          });
        }
      }
    });
  }

  addSessionsFields(
    collectionClone: {
      key: string;
      name: string;
      fields: Array<GenaralRuleField>;
    },
    rule: GeneralRule
  ) {
    rule.conditions.forEach(condition => {
      if (
        [
          FILTERS_NAMES_CONST.SERVICE.FIELDS.SESSION_TEMPLATE.key,
          FILTERS_NAMES_CONST.SERVICE.FIELDS.SESSION_STATE.key
        ].includes(condition.key)
      ) {
        const fieldFound = collectionClone.fields.find(
          item => item.key == condition.key
        );
        if (!fieldFound) {
          collectionClone.fields.push({
            key: condition.key,
            field:
              condition.key ===
              FILTERS_NAMES_CONST.SERVICE.FIELDS.SESSION_TEMPLATE.key
                ? FILTERS_NAMES_CONST.SERVICE.FIELDS.SESSION_TEMPLATE.name
                : FILTERS_NAMES_CONST.SERVICE.FIELDS.SESSION_STATE.name,
            operators: EQUAL_AND_INCLUDES_OPERATORS,
            display: INPUT_TYPE.SELECT,
            showInStopConditios: false
          });
        }
      }
    });
  }

  getClientsCups(event: any) {
    this.cups = event;
  }

  async validateuser(event: string, index: number) {
    try {
      if (event) {
        const userQuery: UserQuery = { name: event };
        if (this.conditionForm.collection.key == FILTERS_NAMES_CONST.TASK.KEY) {
          const dependencyConditionIndex = this.conditionForm.conditions.findIndex(
            condition =>
              condition.key === FILTERS_NAMES_CONST.TASK.FIELDS.DEPENDENCY.name
          );

          userQuery.dependency = [
            this.conditionForm.conditions[dependencyConditionIndex].value[0].key
          ];
        }
        const response: Response<UserPagination> = await this.userService.getUserByFilters(
          userQuery
        );
        if (response.code === Http.NotFound) {
          return Snackbar.popError(
            GENERAL_RULES_CONSTANTS.MESSAGES.USER_DOES_NOT_EXIST
          );
        }

        if (response.code === Http.Found) {
          this.userList[index] = response.data!.userArray.map(item => {
            const items = { key: "", name: "" };
            items.key = item.id;
            items.name = item.name!;
            return items;
          });

          this.UsersListEnable!.push(index);
        }
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST + USER_ACCESS.GET);
      else Snackbar.popError(GENERAL_RULES_CONSTANTS.MESSAGES.REQUEST_FAILED);
    }
  }

  enableRule() {
    this.$emit(GENERAL_RULES_CONSTANTS.EMITTERS.ACTIVE_RULE);
  }
  checkCodependecy(item: string) {
    const dropdownServices: Collection[] = lodash.cloneDeep(this.filterArray);
    const fullCollection = dropdownServices.find(
      item => item.key == this.conditionForm.collection.key
    );
    const codependendField = fullCollection?.fields.find(
      (itemOnCollection: GenaralRuleField) => itemOnCollection.field == item
    );

    if (codependendField && codependendField.codependency) {
      const conditionCodepened = this.conditionForm.conditions.find(
        condition => condition.key == codependendField.codependency?.fieldName
      );

      if (conditionCodepened) {
        if (
          conditionCodepened.value.length &&
          conditionCodepened.value.length > 1 &&
          !codependendField.codependency.allowMultiple
        ) {
          return codependendField.codependency.fieldName + NO_MULTIPLE;
        }
        if (
          codependendField.codependency.fieldValue != "" &&
          conditionCodepened.value.length > 0
        ) {
          if (
            codependendField.codependency.fieldValue !=
            conditionCodepened.value[0].name
          ) {
            return codependendField.codependency.fieldValue;
          }
        }
        return;
      }
      return codependendField.codependency.fieldName;
    }
    return;
  }

  checkIfIsCodependent(
    item: string,
    newOperator?: string,
    deleteItem?: boolean
  ) {
    const dropdownServices: Collection[] = lodash.cloneDeep(this.filterArray);
    const fullCollection = dropdownServices.find(
      item => item.key == this.conditionForm.collection.key
    );
    const codependentField = fullCollection?.fields.find(
      (field: GenaralRuleField) => field.codependency?.fieldName == item
    );

    const codependedCondition = this.conditionForm.conditions.find(
      condition => condition.key == codependentField?.field
    );
    if (codependedCondition) {
      if (deleteItem && codependentField) {
        Snackbar.popInfo(
          GENERAL_RULES_CONSTANTS.MESSAGES.ACTION_BLOCKED_CODEPENDENCY_REQ +
            codependentField.field
        );
        return false;
      } else if (codependentField && newOperator) {
        const parentCondition = this.conditionForm.conditions.find(
          condition => condition.key == item
        );

        if (
          parentCondition &&
          newOperator == INCLUDE_OPERATOR_NAME &&
          codependentField.codependency &&
          !codependentField.codependency.allowMultiple
        ) {
          Snackbar.popInfo(
            GENERAL_RULES_CONSTANTS.MESSAGES
              .ACTION_BLOCKED_CODEPENDENCY_REQ_NOT_MULTIPLE +
              codependentField.field
          );
          return false;
        }
      }
    }
    return true;
  }

  async getInfoGroupsByUserTemplateId(
    userTemplateId: string
  ): Promise<RequestInnerInfo[]> {
    try {
      const { code, data } = await this.userTemplateService.getUserTemplateInfo(
        userTemplateId
      );

      if (code === Http.Found) {
        const infoData = data as UserTemplate;
        const infoGroups =
          (infoData.infoGroups as HeaderInfoGroup[]).map(InfoGroup => {
            const infoGroupTyped = InfoGroup;
            return {
              key: infoGroupTyped._key,
              name: infoGroupTyped.name
            };
          }) ?? [];

        return [
          {
            from: FILTERS_NAMES_CONST.USER.KEY,
            display: FIELD_GROUP_CONSTANTS.FIELD_TYPE.SELECT,
            key: INFO_GROUPS,
            value: INFO_GROUPS_LABEL,
            valueList: infoGroups,
            operatorList: EQUAL_INCLUDES_OPERATORS_LIST
          }
        ];
      } else if (code === Http.NotFound) {
        Snackbar.popInfo(
          GENERAL_RULES_CONSTANTS.MESSAGES.NOT_FOUND_INFO_GROUPS
        );
      }
      return [];
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + USER_TEMPLATES_ACCESS.GET
        );
      else Snackbar.popError(GENERAL_RULES_CONSTANTS.MESSAGES.REQUEST_FAILED);
      return [];
    }
  }

  async getFieldsFromFormTemplateById(
    formTemplateId: string
  ): Promise<RequestInnerInfo[]> {
    try {
      const {
        code,
        data,
        message
      } = await this.formTemplateService.getFormTemplateById(formTemplateId);
      if (code === Http.Found) {
        const fields = (data as FormTemplate).fields;
        const fieldsByVisualElement = await Promise.all(
          fields.length > 0
            ? fields?.map(async field => {
                const fieldValue = field as Field;
                let display = "";
                let value: any[] = [];
                if (Object.keys(field).includes(KEY_LIST) && field.list) {
                  display = FIELD_GROUP_CONSTANTS.FIELD_TYPE.SELECT;
                  value = field.options ?? [];
                } else if (
                  ESCHEMA_TYPES.STRING === fieldValue.visualElement &&
                  fieldValue.schema.format === DATE_LABEL
                ) {
                  display = INPUT_TYPE.DATE_PICKER;
                } else if (
                  ESCHEMA_TYPES.STRING === fieldValue.visualElement &&
                  fieldValue.schema.type === ESCHEMA_TYPES.STRING
                ) {
                  display = FIELD_GROUP_CONSTANTS.FIELD_TYPE.INPUT;
                } else if (
                  FIELD_GROUP_CONSTANTS.FIELD_TYPE.STRING ===
                    fieldValue.visualElement ||
                  (!field.visualElement && !field.list) ||
                  (ESCHEMA_TYPES.STRING === fieldValue.visualElement &&
                    fieldValue.schema.type === INPUT_TYPE.NUMBER)
                ) {
                  display = FIELD_GROUP_CONSTANTS.FIELD_TYPE.NUMBER;
                } else if (
                  FIELD_GROUP_CONSTANTS.FIELD_TYPE.SWITCH ===
                  fieldValue.visualElement
                ) {
                  display = FIELD_GROUP_CONSTANTS.FIELD_TYPE.SELECT;
                  value = STATES_ARRAY;
                } else if (SELECT_TYPES.includes(fieldValue.visualElement)) {
                  display = FIELD_GROUP_CONSTANTS.FIELD_TYPE.SELECT;
                  value =
                    (fieldValue.visualElement ===
                    FIELD_GROUP_CONSTANTS.FIELD_TYPE.RADIO
                      ? fieldValue.schema.enum
                      : fieldValue.schema.items?.enum) ?? [];
                } else if (
                  FIELD_GROUP_CONSTANTS.FIELD_TYPE.SLIDER ===
                  fieldValue.visualElement
                ) {
                  display = FIELD_GROUP_CONSTANTS.FIELD_TYPE.SLIDER;
                  value = [
                    {
                      value: fieldValue!.schema.minimum,
                      title: LABEL_SLIDER.minimum
                    },
                    {
                      value: fieldValue!.schema.maximum,
                      title: LABEL_SLIDER.maximum
                    },
                    {
                      value: fieldValue!.schema["x-step"],
                      title: LABEL_SLIDER.step
                    }
                  ];
                }
                value = value.map(item => {
                  if (typeof item === DATA_TYPES.STRING) {
                    return {
                      key: item,
                      name: item
                    };
                  } else {
                    return {
                      key: !item.value ? item.title : item.value,
                      name: item.title as string
                    };
                  }
                });

                let operatorValues: InnerConditionOperator[] = [];

                if (display === INPUT_TYPE.DATE_PICKER) {
                  operatorValues = DATE_OPERATOR_KEY_NAME_ARRAY;
                } else if (!SAME_OPERATOR_LIST_TYPES.includes(display)) {
                  operatorValues = EQUAL_INCLUDES_OPERATORS_LIST;
                } else if (display == INPUT_TYPE.NUMBER) {
                  operatorValues = NUMBER_OPERATORS_LIST;
                } else {
                  operatorValues = [EQUAL_OPERATOR_KEY_NAME];
                }
                const formsFields = {
                  from: FILTERS_NAMES_CONST.FORM.KEY,
                  key: field.conversationTitle,
                  value: field.conversationTitle,
                  display,
                  valueList: value,
                  operatorList: operatorValues
                };
                return formsFields;
              })
            : []
        );

        return fieldsByVisualElement;
      } else if (code === Http.NotFound) {
        throw new Error(message);
      }
      return [];
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + FORM_TEMPLATES_ACCESS.GET
        );
      else Snackbar.popError(error as string);
      return [];
    }
  }

  validateIfItCanUseDeepLevelCondition(
    condition: ConditionGeneralRules,
    index: number
  ) {
    if (!condition.value) return;
    if (
      (typeof condition.value === DATA_TYPES.STRING ||
        condition.value.length < 2) &&
      DEEP_LEVEL_COLLECTIONS_ALLOWED.includes(condition.key) &&
      LIST_OF_COLLECTIONS_WITH_INNER_CONDITIONS.includes(
        this.conditionForm.collection.key
      ) &&
      (!this.showConditionDeepLevelContainer.includes(index) ||
        this.showConditionDeepLevelContainer.length === 0)
    ) {
      return this.validateServiceTemplate(condition);
    }
    return false;
  }

  validateServiceTemplate(condition: ConditionGeneralRules) {
    if (
      condition.key === DEEP_LEVEL_COLLECTIONS_ALLOWED[2] &&
      this.conditionForm.collection.name === KEYS_OF_USER_TEMPLATE_FORMS.FORMS
    ) {
      if (!condition.value[0]) {
        return false;
      }
      const serviceTemplate = this.serviceTemplates.find(
        serviceTemplate => serviceTemplate.id === condition.value[0].key
      );

      return (
        serviceTemplate &&
        serviceTemplate.type === GENERAL_RULES_CONSTANTS.GROUPS
      );
    }
    return true;
  }

  validateIsDisabledDeepLevelCondition(condition: ConditionGeneralRules) {
    const value = Array.isArray(condition.value)
      ? condition.value[0]
      : condition.value;
    if (value) {
      this.ADD_CONDITION_DEEP_LEVEL = ADD_CONDITION_DEEP_LEVEL;
      return false;
    }

    this.ADD_CONDITION_DEEP_LEVEL =
      GENERAL_RULES_CONSTANTS.TOOLTIP.TEMPLATE_CONDITION;
    return true;
  }

  async setInnerConditionFields(index: number) {
    const condition = this.conditionForm.conditions[index];
    if (condition.key === CUPS) {
      this.innerConditionFields[index] = [...CUPS_KEY_OPS];
    } else if (
      condition.key === KEYS_OF_USER_TEMPLATE_FORMS.TEMPLATE &&
      this.conditionForm.collection.name === KEYS_OF_USER_TEMPLATE_FORMS.USER
    ) {
      this.innerConditionFields[
        index
      ] = await this.getInfoGroupsByUserTemplateId(condition.value[0].key);
    } else if (
      condition.key === KEYS_OF_USER_TEMPLATE_FORMS.TEMPLATE &&
      this.conditionForm.collection.name === KEYS_OF_USER_TEMPLATE_FORMS.FORMS
    ) {
      if (condition.value.length > 0) {
        this.innerConditionFields[
          index
        ] = await this.getFieldsFromFormTemplateById(condition.value[0].key);
      }
    } else if (
      condition.key === KEYS_OF_USER_TEMPLATE_FORMS.SERVICIO &&
      this.conditionForm.collection.name === KEYS_OF_USER_TEMPLATE_FORMS.FORMS
    ) {
      this.innerConditionFields[index] = await this.getServiceTemplate(
        condition.value[0].key
      );
    }
  }

  async getServiceTemplate(key: any): Promise<RequestInnerInfo[]> {
    try {
      const response = await this.serviceTemplateService.getServiceTemplateById(
        key
      );

      if (response.code === Http.Found && response.data) {
        this.serviceTemplate = response.data;
        return [
          {
            from: FILTERS_NAMES_CONST.FORM.KEY,
            display: FIELD_GROUP_CONSTANTS.FIELD_TYPE.SELECT,
            key: GENERAL_RULES_CONSTANTS.GROUPS,
            value: GENERAL_RULES_CONSTANTS.GRUPOS,
            valueList: response.data?.groups?.map(group => ({
              key: group.key,
              name: group.name
            })),
            operatorList: EQUAL_INCLUDES_OPERATORS_LIST
          }
        ];
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(
          FORM_MESSAGES.FORBIDDEN_REQUEST + FORM_TEMPLATES_ACCESS.GET
        );
      else Snackbar.popError(error as string);
    }
    return [];
  }

  async showDeepLevelCondition(index: number) {
    await this.setInnerConditionFields(index);
    this.conditionForm.conditions[index].cleanDataToEdit = true;

    if (this.showConditionDeepLevelContainer.includes(index)) {
      this.showConditionDeepLevelContainer = this.showConditionDeepLevelContainer.filter(
        element => element !== index
      );
      return;
    }
    this.showConditionDeepLevelContainer.push(index);
  }

  deleteDeepCondition(index: number) {
    this.dataToRefreshData = [];
    this.conditionForm.conditions[index].innerConditions = [];
    this.showConditionDeepLevelContainer = this.showConditionDeepLevelContainer.filter(
      element => element !== index
    );
  }

  changeTimeUnit(timeUnit: any, index: number) {
    this.conditionForm.conditions[index].timeUnit = timeUnit;
    this.saveConditions();
    this.activeSaveButton();
  }

  searchCollection(keyWord: string) {
    if (!keyWord) {
      this.filterCollections = this.filterArray;
      return;
    }

    this.filterCollections = this.filterArray.filter(item =>
      item.name.toLowerCase().startsWith(keyWord.toLowerCase())
    );
  }

  async validateUniqueName() {
    this.errorsName = await Utils.checkUniqueName(
      COLLECTIONS_NAME.RULE,
      this.conditionForm.inputRuleName
    );
    this.$emit(
      GENERAL_RULES_CONSTANTS.EMITTERS.IS_VALID_RULE_NAME,
      !(this.errorsName.length > 0)
    );
  }

  setServiceTemplates(servicesTemplates: ServiceTemplateHeader[]) {
    this.serviceTemplates = servicesTemplates;
  }

  addLevelGroupAndStateGroupConditionServiceType(event: any) {
    if (this.conditionForm.collection.key == FILTERS_NAMES_CONST.SERVICE.KEY) {
      const indexFilter = this.filterArray.findIndex(
        item => item.key === FILTERS_NAMES_CONST.SERVICE.KEY
      );

      if (
        this.conditionForm.conditions[event.index].key ==
        FILTERS_NAMES_CONST.SERVICE.FIELDS.SERVICE_TEMPLATE.name
      ) {
        this.addFieldToCollection(
          indexFilter,
          FILTERS_NAMES_CONST.SERVICE.FIELDS.GROUP_LEVEL
        );
      }

      if (
        this.conditionForm.conditions[event.index].key ==
        FILTERS_NAMES_CONST.SERVICE.FIELDS.GROUP_LEVEL.name
      ) {
        this.addFieldToCollection(
          indexFilter,
          FILTERS_NAMES_CONST.SERVICE.FIELDS.STATE_GROUP_LEVEL
        );
        this.addFieldToCollection(
          indexFilter,
          FILTERS_NAMES_CONST.SERVICE.FIELDS.SESSION_TEMPLATE
        );
      }

      if (
        this.conditionForm.conditions[event.index].key ==
        FILTERS_NAMES_CONST.SERVICE.FIELDS.SESSION_TEMPLATE.name
      ) {
        this.addFieldToCollection(
          indexFilter,
          FILTERS_NAMES_CONST.SERVICE.FIELDS.SESSION_STATE
        );
      }
    }
  }

  addFieldToCollection(
    indexFilter: number,
    fieldObject: { key: string; name: string }
  ) {
    if (
      !this.filterArray[indexFilter].fields.find(
        item => item.key === fieldObject.key
      ) &&
      this.groupsLevels.length > 0
    ) {
      this.fields.push(fieldObject.name);
      this.conditionForm.collection.fields.push({
        key: fieldObject.key,
        field: fieldObject.name,
        operators: EQUAL_AND_INCLUDES_OPERATORS,
        display: INPUT_TYPE.SELECT,
        showInStopConditios: false
      });

      return;
    }

    if (this.groupsLevels.length === 0) {
      this.filterProperties(indexFilter, [
        FILTERS_NAMES_CONST.SERVICE.FIELDS.GROUP_LEVEL,
        FILTERS_NAMES_CONST.SERVICE.FIELDS.STATE_GROUP_LEVEL,
        FILTERS_NAMES_CONST.SERVICE.FIELDS.SESSION_TEMPLATE,
        FILTERS_NAMES_CONST.SERVICE.FIELDS.SESSION_STATE
      ]);
    }
  }

  deleteGroupLevelsCondition() {
    if (
      !(this.conditionForm.collection.key == FILTERS_NAMES_CONST.SERVICE.KEY)
    ) {
      return;
    }

    const indexFilter = this.filterArray.findIndex(
      item => item.key === FILTERS_NAMES_CONST.SERVICE.KEY
    );

    if (
      this.conditionForm.collection.key == FILTERS_NAMES_CONST.SERVICE.KEY &&
      this.conditionForm.conditions[this.indexConditionToDelete].key ===
        FILTERS_NAMES_CONST.SERVICE.FIELDS.SERVICE_TEMPLATE.name
    ) {
      this.filterProperties(indexFilter, [
        FILTERS_NAMES_CONST.SERVICE.FIELDS.GROUP_LEVEL,
        FILTERS_NAMES_CONST.SERVICE.FIELDS.STATE_GROUP_LEVEL,
        FILTERS_NAMES_CONST.SERVICE.FIELDS.SESSION_TEMPLATE,
        FILTERS_NAMES_CONST.SERVICE.FIELDS.SESSION_STATE
      ]);
    }

    if (
      this.conditionForm.collection.key == FILTERS_NAMES_CONST.SERVICE.KEY &&
      this.conditionForm.conditions[this.indexConditionToDelete].key ===
        FILTERS_NAMES_CONST.SERVICE.FIELDS.GROUP_LEVEL.name
    ) {
      this.filterProperties(indexFilter, [
        FILTERS_NAMES_CONST.SERVICE.FIELDS.STATE_GROUP_LEVEL,
        FILTERS_NAMES_CONST.SERVICE.FIELDS.SESSION_TEMPLATE,
        FILTERS_NAMES_CONST.SERVICE.FIELDS.SESSION_STATE
      ]);
    }

    if (
      this.conditionForm.collection.key == FILTERS_NAMES_CONST.SERVICE.KEY &&
      this.conditionForm.conditions[this.indexConditionToDelete].key ===
        FILTERS_NAMES_CONST.SERVICE.FIELDS.SESSION_TEMPLATE.name
    ) {
      this.filterProperties(indexFilter, [
        FILTERS_NAMES_CONST.SERVICE.FIELDS.SESSION_STATE
      ]);
    }
  }

  deleteGroupLevelsConditionWhenChangeField(index: number, item: string) {
    if (
      !(this.conditionForm.collection.key == FILTERS_NAMES_CONST.SERVICE.KEY)
    ) {
      return;
    }
    const indexFilter = this.filterArray.findIndex(
      item => item.key === FILTERS_NAMES_CONST.SERVICE.KEY
    );

    const conditionFound = this.conditionForm.conditions.findIndex(
      condition => {
        return (
          condition.key ===
          FILTERS_NAMES_CONST.SERVICE.FIELDS.SERVICE_TEMPLATE.name
        );
      }
    );

    if (conditionFound == -1) {
      return;
    }

    if (conditionFound != index) {
      if (
        this.conditionForm.conditions[index].key ==
          FILTERS_NAMES_CONST.SERVICE.FIELDS.GROUP_LEVEL.name &&
        item == FILTERS_NAMES_CONST.SERVICE.FIELDS.GROUP_LEVEL.name
      ) {
        return;
      }

      if (
        this.conditionForm.conditions[index].key ==
        FILTERS_NAMES_CONST.SERVICE.FIELDS.GROUP_LEVEL.name
      ) {
        this.filterProperties(indexFilter, [
          FILTERS_NAMES_CONST.SERVICE.FIELDS.STATE_GROUP_LEVEL,
          FILTERS_NAMES_CONST.SERVICE.FIELDS.SESSION_TEMPLATE,
          FILTERS_NAMES_CONST.SERVICE.FIELDS.SESSION_STATE
        ]);
      }

      return;
    }

    if (item !== FILTERS_NAMES_CONST.SERVICE.FIELDS.SERVICE_TEMPLATE.name) {
      this.filterProperties(indexFilter, [
        FILTERS_NAMES_CONST.SERVICE.FIELDS.GROUP_LEVEL,
        FILTERS_NAMES_CONST.SERVICE.FIELDS.STATE_GROUP_LEVEL,
        FILTERS_NAMES_CONST.SERVICE.FIELDS.SESSION_TEMPLATE,
        FILTERS_NAMES_CONST.SERVICE.FIELDS.SESSION_STATE
      ]);

      return;
    }
  }

  filterProperties(
    indexFilter: number,
    fieldObject: { key: string; name: string }[]
  ) {
    const createCondition = (item: string, propertyToCompare: string) => {
      let nameCondition = false;
      fieldObject.forEach((field: { [key: string]: string }, index) => {
        nameCondition =
          index == 0
            ? field[propertyToCompare] !== item
            : nameCondition && field[propertyToCompare] !== item;
      });

      return nameCondition;
    };

    this.fields = this.fields.filter(item =>
      createCondition(item, GENERAL_RULES_FILTERS_LIST.MAIN.mainFilterKey)
    );
    this.conditionForm.conditions = _.cloneDeep(
      this.conditionForm.conditions
    ).filter(item =>
      createCondition(item.key, GENERAL_RULES_FILTERS_LIST.MAIN.mainFilterKey)
    );
    this.filterArray[indexFilter].fields = this.filterArray[
      indexFilter
    ].fields.filter(item => createCondition(item.key, KEY_PROPERTY));
  }
}
